import { TableCheckbox } from 'primeng/table';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'miq-tableCheckbox',
  template: `
    <label class="container" (click)="onNativeClick($event)">
      <input type="checkbox" [checked]="checked" (focus)="onFocus()" (blur)="onBlur()" />
      <span class="checkmark"></span>
    </label>
  `,
  standalone: false,
})
export class MiqTableCheckboxComponent extends TableCheckbox {
  onNativeClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    const changeEvent: CheckboxChangeEvent = { originalEvent: event, checked: !this.checked };
    super.onClick(changeEvent);
  }

  /** @override required by PrimeNG 19 */
  onClick(_event: CheckboxChangeEvent) {
    // handled via onNativeClick — no-op to satisfy override contract
  }

  onFocus() {
    // intentional to override default behavior from parent
  }

  onBlur() {
    // intentional to override default behavior from parent
  }
}
